<script>
import baseMixin from '@/mixins/baseMixin'
import timesheetMixin from '@/mixins/timesheetMixin'

export default {
  name: 'DisputeDialogBookingHistorySubmissionAlert',
  mixins: [baseMixin, timesheetMixin],
  computed: {
    showAlert() {
      return (
        !this.activeTimesheet.candidateHasSubmitted ||
        !this.activeTimesheet.clientHasSubmitted
      )
    },
    compAlertText() {
      if (
        !this.activeTimesheet.candidateHasSubmitted &&
        this.activeTimesheet.clientHasSubmitted
      )
        return this.$t('dispute.history.alert.missingCandidate')
      else if (
        this.activeTimesheet.candidateHasSubmitted &&
        !this.activeTimesheet.clientHasSubmitted
      )
        return this.$t('dispute.history.alert.missingClient')
      else return this.$t('dispute.history.alert.noSubmissions')
    },
  },
}
</script>

<template>
  <v-alert
    v-if="showAlert"
    dense
    color="grey lighten-2"
    outlined
    text
    class="mt-4 rounded-lg text-body-2"
  >
    <v-icon left size="20">mdi-alert-circle-outline</v-icon>
    <span
      data-testid="booking-history-submission-alert-text"
      :class="[isDarkMode ? 'white--text' : 'black--text']"
    >
      {{ compAlertText }}</span
    >
  </v-alert>
</template>
